<nb-card *ngIf="page">
  <nb-card-body>
    <div class="row mb-2" #tabla>
      <div class="col-12 p-0">
        <h4 class="titulo">Resultados de la b&uacute;squeda</h4>
      </div>
      <div class="col-12 p-0" *ngIf="texto">
        <h6 class="titulo">{{ texto }}</h6>
      </div>

      <div class="col-12 p-0 mat-elevation-z8">
        <table class="w-full bg-transparent mat-elevation-z8" mat-table [dataSource]="dataSource">
          <ng-container *ngFor="let disCol of (columns); let colIndex = index" matColumnDef="{{disCol}}">
            <th mat-header-cell *matHeaderCellDef class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
              [ngClass]="getClass(disCol)">
              <span class="whitespace-no-wrap" [innerHtml]="disCol">
              </span>
            </th>
            <td mat-cell *matCellDef="let element" [ngClass]="getClass(disCol)">
              <ng-container *ngIf="disCol != 'Acciones'">
                <span [innerHtml]="getValue(element, disCol) | safeHtml"></span>
              </ng-container>
              <ng-container *ngIf="disCol == 'Acciones'">
                <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style"
                  *ngIf="botones.length !== 0">
                  <mat-button-toggle *ngFor="let boton of botones" [hidden]="!boton.visible(element)"
                    [title]="boton?.title?boton?.title:''"
                    (click)="boton.click(element)" [ngClass]="boton.clasesBoton">
                    <mat-icon *ngIf="boton.tieneIcono" [ngClass]="boton.clasesIcono">{{ boton.icono }}</mat-icon>
                    <span *ngIf="boton.etiqueta" [ngClass]="boton.clasesEtiqueta">{{ boton.etiqueta }}</span>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="(columns)"></tr>
          <tr mat-row *matRowDef="let row; columns : (columns)"></tr>
        </table>
        <mat-paginator [length]="page?.totalElements" [pageSize]="50" (page)="paginado($event)"
          [pageSizeOptions]="[50, 100, 150, 200, 10]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </nb-card-body>
</nb-card>